var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEraser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.284 1.23037L13.6073 4.23131C14.1309 4.71122 14.1309 5.47664 13.6073 5.95654L7.4375 11.5393C6.39018 12.4869 4.69166 12.4869 3.63763 11.5393L1.26774 9.39486C0.744086 8.91495 0.744086 8.14953 1.26774 7.66963L8.38411 1.23037C8.91448 0.756542 9.76039 0.756542 10.284 1.23037ZM2.21435 8.53224L4.59095 10.6766C5.11461 11.1565 5.96052 11.1565 6.49089 10.6766L8.86077 8.53224L5.53756 5.52523L2.21435 8.53224Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/eraser.dc8fd4be.svg";
export { ForwardRef as ReactComponent };